import React from 'react';
import styled from 'styled-components';
import { AppLayout } from '../../components/layout';

const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 60px 20px;
  line-height: 1.8;
`;

const Hero = styled.div`
  text-align: center;
  margin-bottom: 60px;
`;

const Title = styled.h1`
  font-size: 3rem;
  color: #1a365d;
  margin-bottom: 20px;
`;

const Lead = styled.p`
  font-size: 1.25rem;
  color: #4a5568;
  max-width: 700px;
  margin: 0 auto;
`;

const Section = styled.section`
  margin-bottom: 60px;
`;

const SubTitle = styled.h2`
  font-size: 2rem;
  color: #2c5282;
  margin-bottom: 24px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 32px;
  margin-top: 40px;
`;

const Card = styled.div`
  padding: 32px;
  background: #f7fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
`;

const CardTitle = styled.h3`
  font-size: 1.25rem;
  color: #1a365d;
  margin-bottom: 12px;
`;

export const AboutUs = () => {
  return (
    <AppLayout>
      <Container>
        <Hero>
          <Title>Our Mission</Title>
          <Lead>We empower businesses to master their field operations through intuitive, data-driven enterprise solutions.</Lead>
        </Hero>

        <Section>
          <SubTitle>The ERP Mock Story</SubTitle>
          <p>Founded in 2026, ERP Mock began with a simple goal: to bridge the gap between complex enterprise backends and the fast-paced reality of field sales. We realized that existing solutions were either too rigid for field use or too simple for management needs.</p>
          <p>Our platform was built from the ground up to provide real-time visibility into every layer of the supply chain, while giving sales representatives the tools they need to succeed in the field without being bogged down by administrative tasks.</p>
        </Section>

        <Section>
          <SubTitle>Our Core Values</SubTitle>
          <Grid>
            <Card>
              <CardTitle>Innovation First</CardTitle>
              <p>We leverage the latest in AI and cloud technology to keep our users ahead of the curve.</p>
            </Card>
            <Card>
              <CardTitle>User Centric</CardTitle>
              <p>Every feature is designed with the end-user in mind, ensuring ease of use and maximum efficiency.</p>
            </Card>
            <Card>
              <CardTitle>Absolute Integrity</CardTitle>
              <p>Transparency and data security are the foundation of everything we build.</p>
            </Card>
          </Grid>
        </Section>
      </Container>
    </AppLayout>
  );
};
